/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _ContinueInputs */

const en__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const ar__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إستمر`)
};

const de__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter`)
};

const es__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const fr__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer`)
};

const it__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua`)
};

const ja__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続ける`)
};

const ko__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계속`)
};

const pt_br__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prosseguir`)
};

const ru__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить`)
};

const th__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดำเนินการต่อ`)
};

const tr__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devam Et`)
};

const zh_cn__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续`)
};

const zh_tw__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繼續`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {_ContinueInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
const _continue = /** @type {((inputs?: _ContinueInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_ContinueInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__continue(inputs)
	if (locale === "ar") return ar__continue(inputs)
	if (locale === "de") return de__continue(inputs)
	if (locale === "es") return es__continue(inputs)
	if (locale === "fr") return fr__continue(inputs)
	if (locale === "it") return it__continue(inputs)
	if (locale === "ja") return ja__continue(inputs)
	if (locale === "ko") return ko__continue(inputs)
	if (locale === "pt_br") return pt_br__continue(inputs)
	if (locale === "ru") return ru__continue(inputs)
	if (locale === "th") return th__continue(inputs)
	if (locale === "tr") return tr__continue(inputs)
	if (locale === "zh_cn") return zh_cn__continue(inputs)
	return zh_tw__continue(inputs)
});
export { _continue as "continue" }